import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { faRavelry } from '@fortawesome/free-brands-svg-icons';
import { faHandPaper } from '@fortawesome/free-regular-svg-icons';
import { faCaretSquareLeft } from '@fortawesome/free-solid-svg-icons';
import { remove } from '@sama/micro-dash';
import { AbstractSecondaryToolbar } from '../../../cross-team-shared/annotation/shared/toolbars/secondary-toolbar/abstract-secondary-toolbar';
import { ToggleButton } from '../../../cross-team-shared/components/toggle-button-group/toggle-button-group.component';
import { shellConnectorToken } from '../../../team-apis/core/shell-connector';
import { PointCloudContentState } from '../../state/point-cloud-content-state';
import { PointCloudContentStore } from '../../state/point-cloud-content-store';
import { EditTool3D } from './edit-tool-3d';

@Component({
  selector: 'h3-edit-secondary-bar',
  templateUrl: './edit-secondary-toolbar-3d.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class EditSecondaryToolbar3DComponent extends AbstractSecondaryToolbar<
  PointCloudContentState,
  PointCloudContentStore,
  EditTool3D
> {
  buttons = this.buildButtons();

  private buildButtons() {
    const buttons: ToggleButton[] = [
      {
        value: 'translate',
        icon: faHandPaper,
        tooltip: 'Translate Mode: for cuboid repositioning',
      },
      {
        value: 'rotate',
        icon: faRavelry,
        tooltip: 'Rotation Mode: for cuboid rotation',
      },
      {
        value: 'select face',
        icon: faCaretSquareLeft,
        tooltip: 'Select Face of Interest for each cuboid',
      },
    ];

    const shellConnector = inject(shellConnectorToken);
    if (shellConnector.hasFeatureFlag('rescale-all-frames_on')) {
      remove(buttons, (button) => button.value === 'scale');
    }

    return buttons;
  }
}
